import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ArrowsArrowLeftRegularIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M12 24c-.089 0-.177-.016-.26-.047l-.022-.008c-.093-.037-.178-.093-.249-.165L.97 13.28c-.142-.14-.222-.33-.222-.53s.08-.39.222-.53c.141-.142.33-.22.53-.22s.389.078.53.22l9.22 9.22V.75c0-.414.336-.75.75-.75s.75.336.75.75v20.689l9.22-9.22c.14-.141.331-.22.53-.22.2 0 .39.08.53.221.142.14.222.33.222.53s-.08.39-.222.53l-10.5 10.5c-.07.07-.154.126-.246.164l-.027.01c-.082.03-.17.046-.257.046z" transform="rotate(90 12 12)"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ArrowsArrowLeftRegularIcon = __decorateClass([
  customElement("elm-arrows-arrow-left-regular-icon")
], ArrowsArrowLeftRegularIcon);
export { ArrowsArrowLeftRegularIcon };
